import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Stopper from '../../../Stopper/Stopper';
import { actions as errorActions } from '../../../../../reducers/error';
/**
 * Stateful component to draw ErrorBoundary
 * @param {string} error
 * @param {string} errorInfo Detailed error info, renders the page.
 * @returns {JSX} Component JSX.
 */

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorInfo: null,
      redirect: '',
    };
  }

  componentDidMount = () => {
    const { history } = this.props;
    history.listen((location) => {
      if (this.state.errorInfo) {
        const { placeWhereError } = this.props;
        if (placeWhereError !== location.pathname) {
          this.setState({ redirect: location.pathname, errorInfo: null });
        }
      } else {
        this.setState({ redirect: '' });
      }
    });
  };

  componentWillUnmount = () => {
    const { history } = this.props;
    if (history) {
      try {
        history.removeEventListener('listen');
      } catch (err) {
        // console.log(`err: ${err}`);
      }
    }
  };

  static getDerivedStateFromError(error) {
    return {
      errorInfo: error,
    };
  }

  componentDidCatch = () => {
    const { showError } = this.props;
    showError({ handlingCode: -69 });
  };

  render() {
    if (this.state.redirect && this.state.errorInfo) {
      this.setState({ redirect: null, errorInfo: null });
      return <Redirect to={this.state.redirect} />;
    }

    if (!this.state.errorInfo) {
      /* Error path */
      /* Normally, just render children */
      return this.props.children;
    }

    return <Stopper handlingCode={-69} />;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showError: errorNormalized => dispatch(errorActions.showError(errorNormalized)),
  };
};
const mapStateToProps = state => ({
  error: state.error.handlingCode,
  placeWhereError: state.error.placeWhereError,
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);
